import { useEffect } from 'react'
import { Link } from 'react-router-dom';
import FooterContact from '../../../component/FooterContact';
import HomeVideo2 from '../../../assets/images/banner/banner-1.mp4';

export default function EnterPriseMobilitySecurity() {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            {/* Hero Banner */}
            <section className="pad60 box-shadow innertopbanner" style={{ position: 'relative', overflow: 'hidden' }}>
                <div className="overlay-top-left"></div>
                <div className="container">
                    <div className="row align-items-center height100 mt-4">
                        <div className="col-lg-7 col-md-12">
                            <div className="banner-caption">
                                <div itemScope itemType="http://schema.org/BreadcrumbList" className="breadcrumbs">
                                    <ul>
                                        <li itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem">
                                            <Link to="/"><span itemProp="name">Home</span></Link>
                                            <meta itemProp="position" content="1" />
                                        </li>
                                        <li itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem">
                                            <i className="icofont-thin-right"></i>
                                            <span itemProp="name">Enterprise Mobility Security</span>
                                            <meta itemProp="position" content="2" />
                                        </li>
                                    </ul>
                                </div>
                                <div className="prod-section-label">Identity & Access Management</div>
                                <h1 className="prod-hero-title">Enterprise <span>Mobility Security</span></h1>
                                <p>Protect enterprise data through robust identity management, advanced threat protection, and comprehensive compliance measures across all devices and environments.</p>
                                <div className="button_services mb-4 mt-4">
                                    <Link to="/contact"><button className="prod-cta-btn">Contact Us &nbsp;<i className="fa fa-arrow-right"></i></button></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <video autoPlay loop muted style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover', zIndex: -1 }}>
                    <source src={HomeVideo2} type="video/mp4" />
                </video>
            </section>

            {/* IAM Overview */}
            <section className="prod-info-section" style={{ background: '#0a0a0a' }}>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="prod-info-image">
                                <img src={require('../../../assets/images/services/products/mobility.jpg')} alt="Enterprise Mobility Security" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="prod-info-content">
                                <div className="prod-section-label">IAM Services</div>
                                <h2>Identity &amp; Access Management</h2>
                                <p>IAM services enable organizations to define, develop, implement, and automate information access controls and privileges. It ensures only authorized individuals have access to the right data at the right time and for the right reasons.</p>
                                <p>Implementing an IAM solution requires audit of existing and legacy systems, deciding which systems to integrate, mapping out all user types and access scenarios — scalable, secure, and compliance-ready.</p>
                                <Link to="/contact" className="prod-cta-btn" style={{ marginTop: '12px', display: 'inline-flex' }}>
                                    Talk to Our Experts <i className="fa fa-arrow-right" style={{ marginLeft: 8 }}></i>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* 3 Core Areas */}
            <section className="prod-highlight-section">
                <div className="container">
                    <div className="text-center mb-5">
                        <div className="prod-section-label" style={{ margin: '0 auto 16px' }}>Core Areas</div>
                        <h2 className="prod-section-title">IAM <span>Core Capabilities</span></h2>
                        <p className="prod-section-sub" style={{ margin: '0 auto' }}>Comprehensive identity and access management across your entire enterprise</p>
                    </div>
                    <div className="prod-features-grid" style={{ paddingTop: 0 }}>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon"><i className="fa fa-id-card"></i></div>
                            <h4>Identity Management</h4>
                            <p>Privileged Identity Management provides the most effective solution to manage superuser accounts across the organization with close monitoring and adequate controls to avoid any compromise.</p>
                            <div className="prod-feature-number">01</div>
                        </div>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon"><i className="fa fa-lock"></i></div>
                            <h4>Security Management</h4>
                            <p>Security Verification Services mitigate cyber risks through comprehensive manual and automated assessments to unveil security gaps and vulnerabilities in applications, networks, and systems.</p>
                            <div className="prod-feature-number">02</div>
                        </div>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon"><i className="fa fa-key"></i></div>
                            <h4>Access Management</h4>
                            <p>Authenticate, authorize, and audit access to applications and IT systems. Ensure the right users have access to the right resources at the right times — on-premises and in the cloud.</p>
                            <div className="prod-feature-number">03</div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Mitigate Risks */}
            <section className="prod-dark-section">
                <div className="container">
                    <div className="text-center mb-5">
                        <div className="prod-section-label" style={{ margin: '0 auto 16px' }}>Risk Management</div>
                        <h2 className="prod-section-title">Mitigate Risks, <span>Maximize Productivity</span></h2>
                        <p className="prod-section-sub" style={{ margin: '0 auto' }}>Don't settle for less than the industry leader in privileged access management</p>
                    </div>
                    <div className="prod-features-grid" style={{ paddingTop: 0 }}>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon"><i className="fa fa-shield"></i></div>
                            <h4>Defend Against Attacks</h4>
                            <p>Secure privileged identities — human and machine — in a tamper-resistant repository, reducing your attack surface significantly.</p>
                            <div className="prod-feature-number">01</div>
                        </div>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon"><i className="fa fa-check-circle"></i></div>
                            <h4>Satisfy Audit &amp; Compliance</h4>
                            <p>Meet internal requirements, manage access and maintain full centralized audit trails to satisfy regulatory and compliance obligations.</p>
                            <div className="prod-feature-number">02</div>
                        </div>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon"><i className="fa fa-globe"></i></div>
                            <h4>Enable Digital Business</h4>
                            <p>Securely authenticate users with VPN-less access from a single web portal, enabling seamless digital transformation at scale.</p>
                            <div className="prod-feature-number">03</div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Why Choose */}
            <section className="prod-highlight-section">
                <div className="container">
                    <div className="text-center mb-5">
                        <div className="prod-section-label" style={{ margin: '0 auto 16px' }}>Why Choose Us</div>
                        <h2 className="prod-section-title">Expert-Led <span>IT Solutions</span></h2>
                    </div>
                    <div className="prod-features-grid" style={{ paddingTop: 0 }}>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon"><i className="fa fa-users"></i></div>
                            <h4>Access to IT Experts</h4>
                            <p>Gain access to technology experts who support your in-house or cloud infrastructure, manage and maintain critical systems, and minimize downtime.</p>
                        </div>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon"><i className="fa fa-phone"></i></div>
                            <h4>Single Point of Contact</h4>
                            <p>A reliable IT advisor for your business, offering managed IT services and a dedicated technical contact who understands your business inside out.</p>
                        </div>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon"><i className="fa fa-dollar"></i></div>
                            <h4>Cost Saving</h4>
                            <p>Eliminate concerns about unexpected costs with a predictable, low monthly fee — more cost-effective than maintaining an in-house IT manager.</p>
                        </div>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon"><i className="fa fa-lock"></i></div>
                            <h4>Proactive IT Security</h4>
                            <p>Identify gaps in your security, provide recommendations to strengthen IT infrastructure, and keep systems up to date with decades of experience.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Automation & Consumer Identity */}
            <section className="prod-dark-section">
                <div className="container">
                    <div className="row g-4">
                        <div className="col-lg-6">
                            <div className="prod-feature-card" style={{ height: '100%' }}>
                                <div className="prod-feature-icon"><i className="fa fa-cogs"></i></div>
                                <h4>Drive Automation</h4>
                                <p>Ensures faster audits, meets compliance needs, enables rapid provisioning and de-provisioning of users, provides time-based user access, tightens security measures, reduces costs and manual effort.</p>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="prod-feature-card" style={{ height: '100%' }}>
                                <div className="prod-feature-icon"><i className="fa fa-user-circle"></i></div>
                                <h4>Manage Consumer Identities</h4>
                                <p>Protect consumer data across networks, meet regulatory needs, drive personalized customer experiences, manage identities at scale, improve business decisions, and strengthen competitive advantage.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* CTA */}
            <section style={{ background: '#0a0a0a', padding: '0 0 80px' }}>
                <div className="container">
                    <div className="prod-cta-banner">
                        <div>
                            <h3>Ready to Secure Your Enterprise Identity?</h3>
                            <p>Get a customized IAM strategy that aligns with your compliance and business requirements.</p>
                        </div>
                        <Link to="/contact" className="prod-cta-btn">
                            Get Started <i className="fa fa-arrow-right" style={{ marginLeft: 8 }}></i>
                        </Link>
                    </div>
                </div>
            </section>

            <FooterContact />
        </>
    )
}
